import React, { useState } from "react";
// import { products } from "../data/products";
import { Link } from "react-router-dom";
import { FaRegHeart, FaRegStar, FaStar } from "react-icons/fa";
import { useSelector } from "react-redux";
import WishCard from "../components/WishCard";

const Wish = () => {
  // Dummy wishlist items
  const products = useSelector(state=>state.wish.wish)
 

  return (
    <div className="w-full mx-auto px-5 md:px-10 py-8">
      <h1 className="text-xl font-bold text-center mb-6">Your Wishlist</h1>

      {products.length === 0 ? (
        <p className="text-center text-gray-500">Your wishlist is empty.</p>
      ) : (
        <div className=" grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 gap-6 justify-between py-10">
          {products.map((data, index) => (
            // <Link to={`/products/${data._id}`}>
            //   <div
            //     key={index}
            //     className="flex w-[166px] sm:w-[261px] mx-auto flex-col justify-center "
            //   >
            //     <div className=" w-[166px] sm:w-[261px] h-[166px] sm:h-[261px] rounded-md relative flex justify-center items-center overflow-hidden ">
            //       <img
            //         src={data.images[0]}
            //         alt="product"
            //         className=" w-full h-full object-cover object-center rounded-md hover:scale-110 duration-200 ease-in"
            //       />

            //         <div className=" p-2 w-[36px] h-[36px] flex absolute top-2 right-2 rounded-full justify-center bg-red-600 items-center text-white hover:bg-black cursor-pointer">
            //           <FaRegHeart />
            //         </div>
            //       <span className=" bg-red-600 absolute text-[10px] px-2 py-1 text-white capitalize font-bold left-0 top-5">
            //         {data.label}
            //       </span>
            //     </div>
            //     <div className=" flex flex-col w-full gap-1 py-2">
            //       {/* <span className=" text-[12px] text-gray-600">
            //         {data.category}
            //       </span> */}
            //       {/* <div className="flex items-center mt-1  text-gray-600">
            //         {[1, 2, 3, 4, 5].map((index) =>
            //           index <= data.rate ? (
            //             <FaStar key={index} color="#ffa569" />
            //           ) : (
            //             <FaRegStar key={index} />
            //           )
            //         )}
            //       </div> */}
            //       <h4 className=" text-[15px] font-bold hover:text-purple-600 cursor-pointer w-fit">
            //         <Link to={`/products/${data._id}`}>{data.name}</Link>
            //       </h4>
            //       <h4 className=" text-[15px] font-boldw-fit text-red-600 font-bold">
            //         {" "}
            //         &#8377; {data.salePrice}{" "}
            //         <span className=" line-through text-gray-700 font-normal text-[12px]">
            //           &#8377; {data.price}
            //         </span>
            //       </h4>
            //     </div>
            //   </div>
            // </Link>
            <WishCard  key={index} data={data}/>
          ))}
        </div>
      )}
    </div>
  );
};

export default Wish;
